import { useAppContext } from "@/contexts/AppContext";

export default function DemoBanner() {
  const { isDemo } = useAppContext();
  if (!isDemo) return null;

  return (
    <div className="fixed top-0 inset-x-0 z-[1001] h-10 bg-amber-500 flex items-center justify-between px-4">
      <span className="text-sm font-medium text-amber-950">
        You are exploring a Fyrris demo account — data is simulated
      </span>
      <a
        href="mailto:charles@fyrris.com?subject=Fyrris%20Access%20Request"
        className="shrink-0 rounded-md border border-amber-800 bg-amber-600 px-3 py-1 text-xs font-semibold text-white hover:bg-amber-700 transition"
      >
        Request Access
      </a>
    </div>
  );
}
